import { RouteLocationNormalized } from 'vue-router';
import { FilterKey } from '@studyportals/search-filters';
import { RouteSearchResults } from './fragments/RouteSearchResults';
import { IFragmentDetails } from './IFragmentDetails';
import { IEmbeddedStateMutable } from '@/url/IEmbeddedStateMutable';
import { IEmbeddedState } from '@/url/IEmbeddedState';
import { NavigationTargetResult } from './NavigationTargetResult';

export abstract class RouteFilter extends RouteSearchResults {
	protected readonly fragmentDetails: IFragmentDetails;
	protected readonly key: FilterKey;

	public constructor(name: string, key: FilterKey, fragmentDetails: IFragmentDetails) {
		super(name);
		this.key = key;
		this.fragmentDetails = fragmentDetails;
	}

	protected override selfRoutePath(): string {
		return this.fragmentDetails.getPathPattern();
	}

	protected override async selfDecodeByPopulatingFrom(
		embeddedState: IEmbeddedStateMutable,
		destination: RouteLocationNormalized
	): Promise<void> {
		const value = await this.fragmentDetails.tryDecodeFrom(destination);
		if (value == null) {
			return;
		}

		embeddedState.withFilterSelection(embeddedState.filterSelectionState.addValueFor(this.key, value));
	}

	protected override async selfEncodeToNavigationTarget(
		navigationTargetResult: NavigationTargetResult
	): Promise<NavigationTargetResult> {
		const selected = navigationTargetResult.remainingEmbeddedState.filterSelectionState.reactive.getFor(this.key);
		const value = selected[0];

		if (await this.fragmentDetails.tryEncodeTo(value, navigationTargetResult.navigationTarget)) {
			navigationTargetResult.remove(this.key, value);
		}

		return navigationTargetResult;
	}

	protected override async selfSupports(embeddedState: IEmbeddedState): Promise<boolean> {
		const selected = embeddedState.filterSelectionState.reactive.getFor(this.key);

		return selected.length === 1 && (await this.fragmentDetails.supports(selected[0]));
	}
}
